import { ApplicationState, IoState, isDone } from "#store/types";
import { isPresent, Optional } from "#types";
import { Interpretation } from "#services/pilotService/types";
import { createSelector } from "reselect";
import { InterpretationsMap } from "#store/interpretations";
import { selectId, selectIds } from "#/selectors";

export const selectInterpretationIdsFavorited = (state: ApplicationState) => {
    return state.uiState.activeInterpretations;
};

export const isFavoritedInterpretation = createSelector(
    [selectInterpretationIdsFavorited, selectId],
    (favs, id): boolean => {
        return favs.includes(id);
    }
);

export const selectInterpretationsMap = (
    state: ApplicationState
): InterpretationsMap => {
    return state.interpretations.interpretations;
};
export const selectInterpretationsIoState = createSelector(
    [selectInterpretationsMap],
    (map): IoState<Interpretation>[] => {
        return Object.values(map);
    }
);

export const selectInterpretationThatArePresentAndDone = createSelector(
    [selectInterpretationsIoState],
    interpretations => {
        return interpretations
            .filter(isPresent)
            .filter(isDone)
            .map(o => o.payload);
    }
);

export const selectInterpretationsThatAreFavorited = createSelector(
    [
        selectInterpretationIdsFavorited,
        selectInterpretationThatArePresentAndDone,
    ],
    (ids: number[], interpretations: Interpretation[]) => {
        return interpretations.filter(i => ids.includes(i.id));
    }
);
export const selectInterpretationById = (
    state: ApplicationState,
    interpretationId: Optional<number>
): Optional<Interpretation> => {
    if (!interpretationId) {
        return null;
    }
    const optionalInterpretation =
        state.interpretations.interpretations[interpretationId];
    if (!optionalInterpretation || optionalInterpretation.state !== "done") {
        return null;
    } else {
        return optionalInterpretation.payload;
    }
};

// export const selectInterpretationByIds = (state:ApplicationState, ids:number[]) : Interpretation[] => {
//     return ids.map(id => selectInterpretationById(state, id)).filter(isPresent);
// }
export const selectInterpretationsRawById = createSelector(
    [selectInterpretationsMap, selectId],
    (map, id): Optional<IoState<Interpretation>> => {
        return map[id];
    }
);

export const selectInterpretationsRawByIds = createSelector(
    [selectInterpretationsMap, selectIds],
    (
        tableIds: InterpretationsMap,
        ids: number[]
    ): IoState<Interpretation>[] => {
        const t: IoState<Interpretation>[] = ids
            .map(id => tableIds[id])
            .filter(isPresent);
        return t;
    }
);

export const selectInterpretationsById = (
    state: ApplicationState,
    interpretationIds: number[]
): Interpretation[] => {
    return interpretationIds
        .map(x => state.interpretations.interpretations[x])
        .filter(isPresent)
        .filter(isDone)
        .map(x => x.payload);
};
